import React, { useEffect, useState } from 'react';

import { useAuth } from '../../../../hooks/auth';

import ProductsService from '../../../../services/ProductsService';

import * as S from './styles';
import * as SM from '../../styles';
import SimpleProduct from '../SimpleProduct';
import PizzaProduct from '../PizzaProduct';
import { GridProduct } from '../GridProduct';
import { useToast } from '../../../../hooks/toast';

interface ProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  editItemToCart: (payload: any) => void;
  seletedEditProductId: number | null;
  cartItem: any;
  colorsAndSizesAll: {
    colors: any[] | null;
    sizes: any[] | null;
  };
}

const ProductEditModal: React.FC<ProductModalProps> = (props) => {
  const {
    isOpen,
    onClose,
    editItemToCart,
    cartItem,
    seletedEditProductId,
    colorsAndSizesAll,
  } = props;

  const { user } = useAuth();
  const { addToast } = useToast();

  const [product, setProduct] = useState<any | null>(null);

  useEffect(() => {
    if (!seletedEditProductId) {
      setProduct(null);
      return;
    }

    const fetchData = async (): Promise<void> => {
      try {
        const response = await ProductsService.showProduct(
          user.empresa_id,
          seletedEditProductId,
        );
        setProduct(response);
      } catch (error) {
        console.log(error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados do produto.',
        });
      }
    };
    fetchData();
  }, [addToast, seletedEditProductId, user.empresa_id]);

  return (
    <SM.CustomModal open={isOpen} onClose={onClose} closeAfterTransition>
      {product ? (
        <>
          {product.controlGrid === 0 && (
            <SimpleProduct
              itemToCart={editItemToCart}
              onClose={onClose}
              product={product}
              cartItem={cartItem}
            />
          )}
          {product.controlGrid === 1 && (
            <GridProduct
              itemToCart={editItemToCart}
              onClose={onClose}
              product={product}
              colorsAndSizesAll={colorsAndSizesAll}
              cartItem={cartItem}
            />
          )}
          {product.controlGrid === 2 && (
            <PizzaProduct
              itemToCart={editItemToCart}
              onClose={onClose}
              product={product}
              colorsAndSizesAll={colorsAndSizesAll}
              cartItem={cartItem}
            />
          )}
        </>
      ) : (
        <S.CustomCircularProgress />
      )}
    </SM.CustomModal>
  );
};

export default ProductEditModal;
